module.exports = __webpack_public_path__ + "static/media/star-icon.e3613eff.svg";